import enLocale from 'element-ui/lib/locale/lang/en'

export const lang = {
  DeleteConversationConfirm: 'Are you sure to delete the conversation?',
  home: 'Home',
  coolguaCloudMatchShowSystem: 'Preschedule Matchmaking System(PMS)',
  exhibitorLogin: 'Exhibitor login',
  buyerLogin: 'Buyer login',
  MemorizePassword: 'Memorize password',
  AutomaticLogon: 'Automatic logon',
  Login: 'Login',
  MobilePhoneNumberOrEmail: 'Mobile phone number or E-mail',
  Password: 'Password',
  validate: 'Verification Code',
  buyerInformation: 'Buyer information',
  ExhibitorInformation: 'Exhibitor information',
  appointmentSchedule: 'Appointment schedule',
  pleaseChangePassword: 'Please change password',
  oldPassword: 'Old password',
  newPassword: 'New password',
  comfirmPassword: 'Comfirm password',
  EditConfirmation: 'Edit confirmation',
  AreYouSureYouWantToChangeYourPassword: 'Are you sure you want to change your password?',
  PasswordSuccessfullyModified: 'Password successfully modified',
  Query: 'Query failed, please try again!',
  search: 'search',
  reset: "Reset",
  save: 'Save',
  cancel: 'Cancel',
  myProfile: "My profile",
  changePassword: 'Change Password',
  logOff: "log off",
  submit: 'Submit',
  return: 'Return',
  cancelled: 'Cancelled',
  CompleteYourProfile: "Complete your profile",
  country: 'country',
  province: 'province',
  city: 'city',
  choose: "Please choose",
  Submission: 'Submit',
  ProductType: 'Product type',
  getFail: 'Get failed!',
  notEmpty: 'Cannot be empty!',
  EnterTheCorrectMobilePhoneNumber: 'Enter the correct mobile phone number.',
  Mobilerepeated: 'Cell phone number repeated, please re-enter!',
  EnterTheCorrectEmail: 'Enter the correct Email.',
  Mailboxrepeated: 'Duplicate mailbox, please re-enter!',
  SuccessfullyChanged: 'Successfully changed',
  UnableToChangePleaseTryAgain: 'Unable to change,please try again.',
  selectPicture: 'Select pictures',
  uploadPicture: 'Upload pictures',
  uploadSuccess: 'Upload success',
  uploadFail: 'Upload fail',
  mustPicture: 'Picture type must be one of. GIF, JPEG, JPG, PNG, BMP',
  MakeAppointments: 'Make appointments',
  close: 'Close',
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
  displayAll: 'Display all',
  displaySuccessfulAppointments: 'Display successful appointments',
  displayPendingAppointments: 'Display pending appointments',
  Exhibitors: 'Exhibitors',
  Buyers: 'Buyers',
  AppointmentInformation: 'Appointment information',
  AppointmentTime: 'Appointment time',
  Initiator: 'Initiator',
  LeaveMessage: 'Leave message',
  PleaseChooseTheAppointmentTime: 'Please choose the appointment time.',
  Time: 'Time',
  AM: 'AM',
  PM: 'PM',
  messageContent: 'Please enter the message content',
  successfulAppointment: 'Successful appointment',
  Total: 'Total',
  appointmentsList: 'Appointments list',
  Download: 'Download',
  To: 'To',
  BoothNO: 'Booth NO.',
  Identity: 'Identity',
  SuccessfullyAcceptTheAppointment: 'Successfully accept the appointment',
  YourRescheduleApplicationHasBeenSentToTheTargetObjectPleaseBePatientAndWaitForFeedback: 'Your reschedule application has been sent to the target object,please be patient and wait for feedback.',
  ChangeTime: 'Change time',
  WaitingForDetermination: 'Waiting for determination',
  Accept: 'Accept',
  AgreeToReschedule: 'Agree to reschedule.',
  SuccessfullyReschedule: 'Agree to reschedule.',
  UnableToSearchPleaseTryAgain: 'Unable to search,please try again.',
  More: 'More/hidden',
  All: 'All',
  seeMore: 'More',
  OrderNumber: 'NO.',
  name: 'Name',
  job: 'Job title',
  Company: 'Company',
  Operator: 'Operation',
  Check: 'Check',
  SuccessfullyMakeAnAppointment: 'Successfully make an appointment.',
  userEmpty: 'User name can not be empty!',
  passwordEmpty: 'Password cannot be empty!',
  codeEmpty: 'Verification code cannot be empty!',
  /*=== begin yiwu */
  "matchToDemands": "matchToDemands", //匹配需求
  "demandForDetails": "demandForDetails", //需求详情
  "productPicture": "Product Picture", //产品图片
  "matchToExhibits": "matchToExhibits", //匹配展品
  "introductionToProducts": "Introduction To Products", //产品介绍
  "MatchToBuyers": "MatchToBuyers", //匹配采购商
  "MatchToDemands": "MatchToDemands", //匹配需求
  "viewMore": "ViewMore", //查看更多
  "查看更多": "ViewMore", //查看更多
  "myInformation": "My Information", //我的资料
  "展商服务": "Exhibitors Service",
  "展商活动": "Exhibitor Activities",
  // "展商直播": "Exhibitor Activities",
  "配套活动": "Supplementary Activity",
  "我的直播": "My Streams",
  "我的预约": "My Appointments",
  "我的消息": "My Messages",
  "我的资料": "Profile",
  "我的需求": "My requires",
  "匹配展商": "Match To Exhibitors",
  "客服电话": "Customer Service Phone",
  "退出登录": "Log Out",
  "查看更多": "View More",
  "原密码": "Old Password",
  "新密码": "New Password",
  "确认密码": "Confirm Password ",
  // "展馆号": "Hall Number",
  // "展位号": "Booth Number ",
  // "产品类型": "Product Type ",
  "暂无": "Not Available ",
  "公司名称": "Company Name",
  "网址": "Url",
  "编辑资料": "Edit Profile",
  "目前没有数据": "No available",
  "宣传视频": "Promotional video",
  "公司介绍": "Introduction ",
  // "展品": "Exhibits ",
  "展商详情": "Exhibitor Profile",
  "搜索": "Search",
  "查看详情": "Check Details",
  "查看": "View ",
  "首页": "Home",
  "视频直播": "Live Video ",
  "业务性质": "Business Nature",
  "感兴趣的产品类型": "Product Category",
  "提交成功": "Post a require successfully.",
  "需求发布成功": "Your enquiry will be posted after review shortly.",
  "数量": "Quantity ",
  "价格幅度": "Price Range ",
  "材质规格": "Material Specifications",
  "需求产品类型": "Required Product Type",
  "查看采购商": "Check Buyers",
  "采购商详情": "Purchaser Details",
  "匹配采购商": "Matching Purchaser",
  "发布的需求": "Published Requirements",
  "序号": "ID",
  "采购商品类型": "Type of Goods Purchased",
  "采购商品名称": "Name of Goods Purchased",
  "采购商品名称英文": "Name of Goods Purchased In English",
  "操作": "Operation & Status",
  "操作成功": "Operation Success",
  "操作成功!": "Operation Success!",
  "视频通话": "Video Call ",
  "发送邀请": "Send Invitations",
  "修改密码": "Change Password ",
  "目前没有匹配数据": "No Matching Data",
  "友情链接": "Links",
  "展会介绍": "About CIOSH",
  "参展商": "Exhibits ",
  "采购商": "Buyers",
  "场馆指南": "Venue Guide",
  "交通指南": "Traffic Guide",
  "修改成功": "Modify Success",
  // "发布需求": "Post a Require",
  "发布": "Post",
  "匹配展品": "Match To Exhibits",
  "人": "Unit",
  "预约视频会议": "Invite",
  "发送消息": "Send Message ",
  "审核通过": "Approved",
  "编辑": "Edit",
  "采购商/采购企业名称": "Purchaser/Name of Enterprise",
  "国家": "Country",
  "采购商品品类": "Category of Goods Purchased",
  "产品名称不能为空": "Product name cannot be empty",
  "请选择产品类别": "Please select a product category",
  "需求名称": "Product Name",
  "产品名称": "Product Name",
  "名称": "Name",
  // "名称": "Name",
  "采购商品数量": "Quantity ",
  "材质/规格": "Texture/Specification",
  "图片1": "Picture 1",
  "图片2": "Picture 2",
  "图片3": "Picture 3",
  "图片4": "Picture 4",
  "取消": "Cancel",
  "取消成功": "Cancel success",
  "点击上传": "Upload",
  "保存修改": "Save",
  "返回": "Back",
  // "活动": "Activity ",
  "会议房间 数量": "Number of Conference Rooms",
  "洽谈时长 （分钟）": "NegotiationTime(minutes)",
  "会议已结束": "End",
  // "商贸配对活动": "Business Match-making",
  "活动列表": "List of Activities",
  "活动时间": "Activity Time ",
  "活动规则": "Activity Rules ",
  "产品类别": "Product Category ",
  "预计时间": "Estimated  Time ",
  "暂无数据": "No Data ",
  "您还没有完善个人信息，请填写完毕后在操作": "Please register first before moving on. Thank you",
  "请填写主题": "Please enter the subject",
  "暂无活动": "No Activity",
  "进入会议": "Enter",
  "进入": "Enter",
  "视频结束": "End of the video",
  "活动已结束": "Activity Has Ended",
  "状态": "Status",
  "进行中": "Ongoing",
  "未开始": "Not Started ",
  "已结束": "Ended",
  "国籍": "Nationality",
  "预约主题": "Subject",
  "日期": "Date",
  "会议时间": "Meeting Time (Beijing Time)",
  "开始时间": "Start Time ",
  "会议开始时间": "Meeting start time",
  "会议结束时间": "Meeting end time",
  "结束时间": "End Time",
  "留言": "Leave a message",
  "确认": "Confirm",
  "我的产品": "My Product",
  "我的点赞": "My Liked",
  "点赞": "Like",
  "收藏": "Collect",
  "我的收藏": "My Favorite",
  "点赞我的": "Like me",
  "收藏我的": "Collect me",
  "新增产品": "Add Product",
  "产品中文名称": "Product Name in Chinese",
  "产品英文名称": "Product Name in English",
  "产品图片": "Product Picture ",
  "设为封面": "Set As Cover",
  "产品中文简介": "Product Introduction in Chinese",
  "产品英文简介": "Product Introduction in English",
  "保存": "Save",
  "参展商登录": "Exhibitor Login",
  "专业观众登录": "Purchaser Login",
  "请输入验证码": "Image verification  code",
  "确定": "Confirm",
  "获取验证码": "Get Verification Code",
  "记住密码": "Remember Password ",
  "自动登录": "Automatic Login ",
  "手机号码或邮箱": "MobilePhone or Email",
  "请输入手机号码或邮箱": "Please Enter MobilePhone or Email",
  "请输入账号": "Please Enter Account",
  "请输入密码": "Enter Password",
  "请输入价格幅度": "Please input target price range",
  "获取邮箱验证码": "Mailbox verification",
  "后可重新发送": "",
  "请输入手机号": "Mobile",
  "手机号": "Mobile",
  "手机": "Telephone Number",
  "邮箱": "Email",
  "请输入邮箱": "Please Enter Email",
  "账号": "Account",
  "请输入手机验证码": "Mobile Verification Code",
  "验证码": "Verification Code",
  "请输入邮箱验证码": "Email code",
  "请输入邮箱!": "Please Enter Email !",
  "邮箱格式不对": "Incorrect email",
  "更多说明": "Description",
  "删除": "Delete",
  "到": "to",
  "发起预约": "Book a video meeting",
  "发起预约弹窗留言": "Leaves a message",
  "取 消": "Cancel",
  "确 认": "Confirm",
  "预约成功": "Appointment successful",
  "请输入": "Search",
  "请输入关键字": "Search Keyword",
  "上传": "Upload",
  // "会议开启倒计时": "Countdown Meeting",
  "活动名称": "Activity Name",
  "确 定": "Confirm",
  "公司图片": "Company Image",
  "倒计时": "Countdown",
  "图片1不能为空": "Picture 1 cannot be empty",
  "公司简介": "Company Profile",
  "立即预约": "Appointment Now",
  "查看预约": "Check",
  "洽谈时长(分钟)": "Communication Time (m)",
  "热门展商": "Hot Exhibitors",
  "采购需求": "In-Demand",
  "热门采购需求": "Active Enquiry",
  "展商名称": "Exhibitors Name",
  "没有获取到对应的数据": "No Corresponding Data Was Obtained",
  "登录成功": "Login Success",
  "注册": "Register",
  "如您未注册请您先": "If Not Registered Please ",
  "确定要切换语言吗？": "Are you sure you want to switch languages?",
  "选择日期": "Date",
  "采购商品类": "Category of Purchaser",
  "会议房间数量": "Number Of Rooms",
  "在线人数": "online",
  "目前还没有人留言,留下你的精彩评论吧": "No one has left a comment yet, so leave a comment",
  "发送": "Send",
  "请完善您的资料": "Add a photo to personalise your account",
  "提交": "Submit",
  "已拒绝": "Rejected",
  "已取消": "Cancelled",
  "待确认": "To be confirmed",
  "已确认": "Confirmed",
  "我收到的预约": "Bookings I received",
  "被拒绝": "Rejected",
  "我发起的预约": "Bookings I sent",
  // "公司": "Company",
  "邀约时间": "Book to meet at",
  "邀约成功": "Successful invitation",
  "发起时间": "Bookings sent at ",
  "被发起时间": "Bookings received at",
  "我的日程": "My Schedules",
  "上个月": "Last Month ",
  "下个月": "Next Month",
  "联系人": "Contact",
  "取消预约": "Cancel ",
  "提醒对方": "Remind",
  "已过期": "Expired ",
  "之后可以操作": "s",
  "再次发起预约": "Appoint Again",
  "确定要注销吗": "Are you sure you want to log off",
  "注销成功，界面即将刷新": "Log out successfully, the interface is about to refresh",
  "结束会议": "End Meeting",
  "退出视频": "Leave",
  "退出会议": "Leave",
  "拒绝": "Reject",
  "发起直播": "Broadcast",
  "服务器和串流密钥只生成一次,请妥善保管": "The server and stream keys are generated only once. Please keep them safe",
  "发起直播方法": "Method of Live Broadcasting",
  "小程序:请打开扫码开始直播": "MiniProgram : Please open and scan code to start the live broadcast",
  "PC端": "PC",
  "OBS推流": "OBS Push Flow",
  "开启直播": "Open Live",
  "点击查看操作手册": "View Manual",
  "服务器": "Server",
  "串流密钥": "Streaming Key",
  "查看直播": "View This Live",
  "点击查看直播": "View",
  "直播主题": "Theme",
  "时长": "Duration",
  "直播状态": "Status",
  "直播中": "Live Now",
  "结束": "End ",
  "累计观看人数": "Views Number",
  "累计观看人次": "Views Number",
  "转化预约数": "Number Of Conversion Bookings",
  "你还没有直播过呢,快点发起直播吧~~~": "Null",
  "我的直播名称": "Name",
  "直播封面": "Cover",
  "开始直播": "Start",
  // "直播名称": "Name",
  "暂无预约": "Null",
  "取消会议": "Cancel",
  "预约时间": "Time",
  "成功": "Success",
  "请输入直播名称": "Name",
  "展品列表": "Exhibits List",
  "对方还未登录系统，暂时不能联系": "off-line",
  "待审核": "WaitConfirmed",
  "暂无需求": "Not Data",
  "正在直播中": "Living",
  "审核状态": "Status",
  "编辑产品": "Edit Product",
  "立即查看": "View",
  "公司地址": "Company Address",
  "请先输入图片验证码": "Please Enter  Image Verification Code First",
  "暂无选择视频": "Not Video",
  "需求图片": "Need Photo",
  "提示": "Tips",
  "您的设备不支持视频通话，请使用PC端谷歌浏览器打开": "Your device does not support video call, please use PC Google browser",
  "登录": "Login",
  "退出": "Logout",
  // "展商": "Exhibitor",
  "观众": "Buyers",
  "更多": "More",
  "个人中心": "My Account",
  "同期活动": "Concurrent Activities",
  "报名人数": "Reg Number ",
  "时间": "Time",
  "参加报名": "Sign",
  "推荐需求": "Recommend Requirements",
  "推荐观众": "Recommend Buyers",
  "暂时没有需求列表": "There is no list of requirements",
  "暂时没有观众列表": "There is no list of requirements",
  "暂时没有发起直播": "There is no list of living",
  "下一页": "Next page",
  "上一页": "Previous page",
  "热门推荐": "HOT",
  "客服热线": "ServiceLine",
  "通信地址": "Address",
  "主办单位": "Company",
  "热门直播": "Hot Live",
  "推荐展商": "Recommended Exhibitors",
  "推荐展品": "Recommended Exhibits",
  // "预约": "Reservation",
  "咨询": "Advisory",
  "公司": "Company",
  "产品类型": "Product Type",
  "主营的产品类型": "Main Product Types",
  "地址": "Address",
  "取消报名": "Cancel Sign",
  "已全部加载": "All Loaded",
  "点击加载": "SeeMore",
  "加载中": "loadinging",
  "验证码错误!": "Verification code is not correct",
  "验证码错误！": "Verification code is not correct",
  "请输入正确的邮箱!": "please enter your vaild email !",
  "产品视频": "Video",
  "热门视频": "Video",
  "产品编辑": "ProductEditor",
  "产品新增": "NewProduct",
  "场馆导航": "Navigation",
  "专业观众": "Audience",
  "会议直播": "Exhibitor Interview",
  "启动仪式": "Exhibitor Start",
  "预约洽谈": "Demand List",
  // "展商直播": "Exhibitor Live",
  "不能和自己通话": "Can not call yourself",
  "请输入图片验证码": "Please enter the picture verification code",
  "不能给自己发消息": "Can not call yourself",
  "发消息": "Send a massage",
  "标题": "Title",
  "直播类型": "Type",

  "展商入口": "Exhibitor Login",
  "观众入口": "Buyer Login",
  "前往深圳展": "Shenzhen Edition",
  "视频直播": "Live Vide",
  "展商展品": "Exhibits",
  "参观指引": "Visitor Guide",
  "平台操作指引": "Exhibitor Guide",
  "会刊下载": "Downloads",
  // "个人中心": "My Profile",
  // "热门展商": "Hot Exhibitors",
  // "查看更多": "More",

  // "展商": "Exhibitor",
  // "展品": "Product",
  // "筛选": "Filter by",
  // "热度": "Popularity",
  "正在直播": "Live Now",
  // "推荐": "Recommendation",

  // "展会分馆": "Pavilion",
  // "所有": "All",
  "W1雕刻馆": "W1 Cutter",
  "W2耗材馆": "W2",
  "W3标识馆": "W3 Signage",
  "W4喷印馆": "W4",
  "W5喷印馆": "W5",
  "E1数字标识馆": "E1 ",

  "展馆号": "Hall No.",
  "展位号": "Booth No.",
  "预约": "Make Appointment",
  "历史直播": "Rewind",

  "全部分类": "All Type",
  "你还没有完善个人信息，请填写完善后再操作": "Please complete your registration before moving forward.",
  "修改头像": "Upload Your image",


  // 观众PC2.0展商列表
  "展商": "Exhibitors",
  "展品": "Products",
  "筛选": "Filter by",
  "热度": "Popularity",
  "推荐": "Recommendation",

  "展会分馆": "Pavilion",
  "所有": "All",
  "W1 雕刻馆": "W1 Cutter",
  "W2 耗材馆": "W2 Materials",
  "W3 标识馆": "W3 Signage",
  "W4 喷印馆": "W4 Spray printing",
  "W5 喷印馆": "W5 Spray printing",
  "E1 数字标识馆": "E1 Digital",

  //【观众PC】2.1展商详情
  "展商介绍": "Exhibitor Profile",
  "主营产品": "Main Products",

  //【观众PC】2.1展商详情

  "所属类别": "Category",


  "视频直播": "Exhibitor Live Showroom",
  "展商直播": "Exhibitor Live Showroom",
  "展品介绍": "Exhibits Profile",
  // 【观众PC】3.0展品列表
  "请输入展品名称": "search exhibitor and product",
  // 【观众PC】4.0直播列表
  "大会快看": "Exhibitor Interview",
  "展会现场实时直播": "Real-time Today",
  "全球大咖带你逛SIGN": "CHINA	KOLs in SIGN CHINA",
  "会议视频": "Conferences",
  "精彩视频": "js video",
  "亚洲": "Asia",
  "欧洲": "Europe",
  "美洲": "America",
  "大洋洲": "Oceanic",
  "非洲": "Africa",
  // 【观众PC】4.3主办直播详情（巡馆展开）
  "闻信": "Informa Markets Trust Co Ltd",
  "一起聊聊": "input here",
  "猜你喜欢": "Recommended",
  "人观看中": "Watching",
  // 【观众PC】5.0需求列表
  "采购规格": "Description",
  "采购数量": "Quantity",
  "采购人": "Released by",
  // 【观众PC】6.0商贸配对活动
  "活动": "Subject",
  "会议房间（数量）": "Meeting Rooms",
  "洽淡时长（分钟）": "Meeting  Duration (mins)",
  // 【观众PC】6.1商贸配对活动（活动详情）
  "会议入口": "Action",
  "返回上一页": "Back",

  // 观众PC】8.0会刊下载
  "下载": "Download",

  // 【观众PC】8.0会议直播

  // 【观众PC】8.0专场采购对接会
  "专场采购对接会": "Booth Visit",

  // 【观众PC】9.1我的需求（未添加需求）
  "未发布需求": "No posted enquiries yet",
  "点赞收藏": "Likes & Favorites",
  "单位名称": "Company",
  "职务": "Job title",
  "兴趣展品": "Product of Interest",
  "商务配对活动": "Business Matching",
  // 【观众PC】9.1.1发布需求
  "选择文件": "Select file",
  "文件预览": "Preview",
  // 【观众PC】9.2我的预约(已确认)
  "已确定": "Confirmed",
  "待确定": "Pending",
  // 【观众PC】9.3我的日程
  "全部日程": "All Schedule",
  "备注留言": "Message",
  "邀约": "Invited",
  "我发起的": "By me",
  "展商发起的": "By exhibitor",
  // 【观众PC】9.4我的消息
  "全部消息": "All messages",
  "系统消息": "System message",
  "关闭": "Close",
  // 【观众PC】9.5点赞收藏（展品）
  "展商收藏": "Favorite Exhibitors",
  "展商点赞": "Liked Exhibitor",
  "展品收藏": "Favorite Products",
  "展品点赞": "Liked Products",
  "收藏我的展商": "Added to Favorite by",
  "点赞我的展商": "Liked by",
  "收藏我的采购商": "Added to Favorite by Buyers",
  "点赞我的采购商": "Liked by Buyers",
  "观众登录": "Buyer",
  "展商登录": "Exhibitor",
  "获取短信验证": "Get SMS Verification",
  "我的展品": "My Exhibits",
  "VR展台": "VR展台",
  "展会分馆实时画面": "Real-time Today",
  "分馆实时画面": "Real-time Today",
  // "全球大咖带你逛SIGN CHINA": "KOLs in SIGN CHINA",
  "展馆": "Exhibition Hall",
  "展品名称": "Display name",
  "展品名称中文": "Exhibit Name(Chinese)",
  "图片直播": "image live",
  "选择图片": "Select Image",
  "图片上传": "Image Upload",
  "视频上传": "Upload Video",
  "展品类别": "Exhibits range",
  "上传封面": "Upload the cover",
  "会议开启倒计时": "Countdown to the meeting",
  "商贸配对活动": "Trade matching Activities",
  "商贸配对活动单位名称": "Name of trade matching activity unit",
  "人观看": "Watch",
  "暂时没有数据": "No Data ",
  "拼命加载中": "Loading desperately",
  "直播标题": "Live the title",
  "是否公开": "Whether The Public",
  "公开": "Public",
  "不公开": "No Public",
  "建议尺寸": "Suggested Size",
  "格式": "Layout",
  "直播视频": "Live video",
  "发起方式": "By way of",
  "PC端发起直播": "Launch Live on PC",
  "暂停": "Pause",
  "上传直播": "Upload live",
  "没有数据": "No Data ",
  "回放": "Playback",
  "展品详情": "Exhibit Detail",
  "全部": "All",
  "专题展区名称": "Sector",
  "展商分类": "Exhibitors Classification",
  "展品分类": "Exhibits Classification",
  "需求列表": "List of Demand",
  "采购人企业": "Purchaser Enterpris",
  "热门采购商需求": "Hot Buyer Demand",
  "品牌企业推荐": "Recommended Exhibitors",
  "特别鸣谢大会支持单位": "Special Thanks to",
  // "全球大咖带你逛SIGN CHINA": "KOLs in SIGN CHINA",
  // "大会直播列表": "Conference Broadcast List",
  "展会现场实时直播列表": "Live live list of the exhibition",
  "大会直播列表": "Conference Broadcast List",
  // "参观指引": "Visitor Guide",


  "分管实时画面": "RealTimeScreen",
  "观看": "",
  "展品展商": "Exhibits",
  "展商名录": "Exhibitors",
  "参展展品": "Exhibits",
  // "展商收藏": "Favorite Exhibitors",
  // "展商点赞": "Liked Exhibitor",
  // "展品收藏": "Favorite Products",
  // "展品点赞": "Liked Products",
  // "收藏我的展商": "Added to Favorite by",
  // "点赞我的展商": "Liked by",
  // "收藏我的采购商": "Added to Favorite by buyers",
  // "点赞我的采购商": "Liked by buyers",
  // "观众登录": "Buyer",
  // "展商登录": "Exhibitor",
  // "获取短信验证": "Get SMS Verification",
  // "发布展品": "PublishExhibits",
  // "我的展品": "MyExhibits",
  // "全球大咖带你逛SIGN CHINA": "Global Voices SIGN CHINA",
  // "展馆": "Exhibition Hall",
  // "展品名称": "Display name",
  // "选择图片": "Select Image",
  // "图片上传": "Image Upload",
  // "视频上传": "Upload Video",
  // "展品类别": "Exhibits range",
  // "上传封面": "Upload the cover",
  // "会议开启倒计时": "Countdown to the meeting",
  // "商贸配对活动": "Business Match-making",
  // "商贸配对活动单位名称": "Name of trade matching activity unit",
  // "人观看": "Watch",
  // "暂时没有数据": "No Data ",
  // "直播标题": "Live the title",
  // "是否公开": "Whether the public",
  // "公开": "Public",
  // "不公开": "No Public",
  // "建议尺寸": "Suggested Size",
  // "格式": "Layout",
  // "直播视频": "Live video",
  // "发起方式": "By way of",
  // "PC端发起直播": "Launch Live on PC",
  // "暂停": "Pause",
  // "上传直播": "Upload live",
  // "没有数据": "No Data ",
  // "回放": "Playback",
  // "展品详情": "exhibitDetails",
  // "全部": "All",
  // "专题展区名称": "Sector",
  // "需求列表": "List of Demand",
  // "采购人企业": "Purchaser Enterpris",
  // "热门采购商需求": "Hot Buyer Demand",
  "热门需求": "Active Enquiry",
  // "品牌企业推荐": "Recommended Exhibitors",
  // "特别鸣谢大会支持单位": "Special Thanks to",
  "特别鸣谢": "Special Thanks to",
  "全球大咖带你逛Sign China": "Global Voices SIGN CHINA",
  "全球大咖带你逛": "Global Voices SIGN CHINA",
  // "大会直播列表": "All Organiser Webcast",
  // "展会现场实时直播列表": "Live live list of the exhibition",
  // "大会直播列表": "Conference Broadcast List",
  // "参观指引": "Visitor Guide",
  "职位": "Post",

  // "分管实时画面": "RealTimeScreen",
  // "观看": "view",
  // "展品展商": "Exhibits",
  // "展商名录": "Exhibitors",
  // "参展展品": "Exhibits",
  "观众收藏": "AudienceCollection",
  "观众点赞": "AudienceLikes",
  "需求收藏": "DemandCollection",
  "需求点赞": "DemandLike",
  "已发布商机": "Published Opportunities",
  "已发布采购需求": "Purchase Requirements",
  "采购名称": "Purchase Name",
  "图片": "Images",
  // "全球大咖带你逛": "Global Voices",
  "实时聊天": "ChatRoom",
  "展会主办单位": "Exhibition Unit",
  "闻信展览": "Trust Informarkests",
  "上海办公室": "Shanghai Office",
  "工作办公室": "office",
  "深圳办公室": "Shenzhen Office",
  "没有更多": "No More",
  "查看视频": "View Video",
  "采购对接会": "Booth Visit",
  "视频聊天": "Video Call",
  "直播名称": "Live Name",
  "观看": "",
  "职位": "job",
  // "观看": "view",
  // "职位": "job",
  "关键字": "search",
  "图片验证码": "Image Code",
  "短信验证码": "SMS Code",
  "密码": "Password",
  "邮箱验证码": "Email Verification Code",
  "获取邮箱验证": "Get Email Verification",
  "获取邮箱验证": "Verify Verification",
  "展品名称英文": "Exhibit Name",
  "请输入展品名称": "Please enter the exhibit Name",
  "英文展品介绍": "Introduction",
  "需求名称(英文)": "Product name（english）",
  "需求名称(中文)": "Product name（chinese）",
  "已暂停": "Pause",
  "恢复": "Resume",
  "停止直播不能再恢复，确定吗？": "Stopping the live broadcast cannot be resumed, Are you sure?",
  "视频": "Video",
  "确定吗?": "Are you sure to leave?",
  "切换视频": "Switch camera ",
  "直播回放": "Live Playback",
  "需求类型": "types",
  "需求介绍": "Introduction",
  "展商暂未发布展品": "Exhibitor hasn't posted any products yet",
  "发布展品": "Post product",
  "主营展品": "Main Exhibits",
  "主营产品类型": "Product Type",
  "发布需求": "Publish Demand",

  "公司名称不能为空": "Please enter company name",
  "名称不能为空": "Please enter name",
  "联系人不能为空": "Please enter your name",
  "手机号不能为空": "Please enter phone number",
  "邮箱不能为空": "Please enter your email ",
  "我收藏的采购商": "Favorite Buyers",
  "我点赞的采购商": "Liked Buyers",
  "我收藏的展商": "Favorite Exhibitors",
  "我收藏的采购需求": "Favorite requires",
  "我点赞的采购需求": "Liked requires",
  "收藏的展商": "Favorite Exhibitors",
  "我点赞的展商": "Liked Exhibitors",
  "我收藏的展品": "Favorite Products",
  "我点赞的展品": "Liked Products",
  "收藏的观众": "Favorite buyers",
  "点赞的观众": "Liked by buyers",
  "关注我的观众": "Add to favorite by",
  "产品封面": "Product Cover",


  "公司名称": "Company Name",
  "公司英文名称": "English company name",
  "展品类型": "Product Type",
  "洽谈时间(分钟)": "Negotiation time",
  "搜索关键词": "search keyword",
  "关注我的展商": "Added to Favorite by",
  "点赞的展商": "Liked by Exhibitors",
  "内容": "content",
  "需求": "Requires",
  "全球大咖带你逛 Sign China": "Global Voices",
  // "西部文化产业巡礼": "Global Voices",
  "西部文化产业巡礼": "Continent",
  "广州办公室": "Guangzhou office",
  "前往上海展": "Physical Show",
  "您的设备不支持视频通话，请尝试其他浏览器": "Your device does not support video calling, Please try another browser",
  "是否允许打开摄像头和麦克风": "Do you allow the camera and microphone to be turned on",
  "视频邀约": "Video invitation from",
  "视频邀约,点击查看": "A new video call invitation, click to join",
  "点击查看": "Click to check",
  "历史回放": "history",
  "停止": "end",
  "暂停中": "pause",
  "已没有更多": "No More",
  "为发布展品": "none exhibits",
  "展商/展品": "exhibitor/exhibit",
  "深圳展": "Shengzhen",
  "上海展": "Shanghai Edition",
  "请输入搜索关键词": "keyword",
  "发布时间": "createTime",
  "公司英文介绍": "Introduction",
  "主题": "theme",
  "获取验证码操作过于频繁，请稍后在试": "Please try again in a minute.",
  "目前没人在直播": "Go ahead to invite your audience now",
  "采购商品名称不能为空": "Please input the product name of your require",
  "对方未登陆": "This contact is offline now.",
  "确定要取消预约吗？": "Are you sure to cancel your appointment?",
  " 还没有人找您聊天": "还没有人找您聊天",
  "观看人数": "number",
  "对方未登录": "The Other is not logged",
  "展商未登录": "The exhibitor is offline",
  "观众未登录": "The visitor is offline",
  "没有需求": "not demands yet",
  "未发布展品": "No products listed. Launch new products now.",
  "请选择": "please select",
  "请输入留言": "You can leave a message here",
  "请输入": "Please enter",
  "选择联系人": "Select contacts",
  "名称": "Name",
  "修改头像": "Modify avatar",
  "确定要退出吗": "Are you sure you want to quit?",
  "获取验证码操作太频繁,请稍后再试": "The operation is too frequent, please try again later",
  "还没有人找您聊天": "Not messages yet",
  "了解更多": "View More",
  "暂无直播": "No Live yet",
  "修改密码成功": "success",
  "原密码不能为空": "The original password cannot be empty",
  "新密码不能为空": "New password cannot be empty",
  "确认密码不能为空": "confirm password can not be blank",
  "请确认新密码与确认密码是否一致": "Please confirm whether the new password is consistent with the confirmed password",
  "确定要取消预约吗": "Are you sure to cancel?",
  "请填写会议开始时间": "please select startTime",
  "请填写会议结束时间": "please select endTime",
  "请选择联系人": "please select contacts",
  "选择时间": "selectTime",
  "邀约发送成功": "Success",
  "商品品类至少选择一个": "Please select Category of Goods Purchased",
  "至少需要一个图片": "Please upload images",
  "图片文件不能大于1M": "image  cannot be larger than 1M",
  "请先上传视频封面": "Please upload video cover",
  "您当前账号没有直播权限，请联系主办工作人员申请直播权限": "Your  account does not have live broadcast permission",
  "上传回放成功": "success",
  "直播名字不能为空": "Live broadcast name cannot be empty",
  "请先上传视频": "Please upload video",
  "请先上传封面": "Please upload the cover",
  "预约提示发送成功": "success",
  "确定要取消预约吗?": "Are you sure to cancel?",
  "请输入正确的邮箱": "please enter your correct email",
  "该联系人不在线": "The contact is not online",
  "视频文件不能大于50M": "The video file cannot be larger than 50M",
  "感兴趣产品": "Products of interest",
  "主营产品类型": "Main product type",
  "请先填写标题": "Please enter title",
  "我已阅读，并且同意": "I have read and agree",
  "未上传任何文件": "No files uploaded",
  "不能为空": "Can not be empty",
  "上传图片像素最好不小于216*205": "Upload picture pixels should not be smaller than 216*205",
  "媒体详情": "Media details",
  "场外展商": "Off-site exhibitors",
  "回放直播": "Replay",
  "上传展品图": "Upload exhibit image",
  "展商推荐": "Exhibitor recommendation",

  // "LED大屏显示": "Germany",
  "LED大屏显示": "Iran",
  // "LED照明": "India",
  "LED照明": "Continent",
  "数字标牌": "Bangladesh",
  "专业灯光音响": "Korea",
  "其他": "Bengal",
  "会议视频列表": "Exhibitor Interview",
  "大会官网": "Physical Show",
  "您有一个会议正在进行中": "You are in a meeting",
  "Shift+Enter发消息": "To send, please press Shift+Enter",
  "信息不能为空": "Can not send an empty message",
  "用户名或密码错误，请重新输入！": "The account or password is wrong, please re-enter!",
  "请先上传直播封面": "Please upload a cover image",
  "操作失败": "Operation failed",
  "请输入展品名称": "search exhibits",
  "请输入展商名称": "search exhibitors",
  "观众预登记": "Visitor Pre-registration",
  "综合服务": "Service",
  "下届展位预订": "105th CIOSH Booth Application",
  "需求对接": "In-Demand",
  "云相册": "Photo Gallery",
  "元宇宙会议": "MetAverse",
  "线上展馆": "Online Pavilion",
  "联系我们": "Contact Us",
  "中国纺织品商业协会": "China Textile Commerce Association",
  "联系电话": "Phone",
  "预登记": "Visitor Pre-registration",
  "劳保会": "Online.Ciosh.com",
  "页": "page",
  "跳转至": "Go to",
  "没有可用的数据": "No data available",
  "选择视频": "Select video",
  "产品名称(中文)": "Product name(chinese)",
  "产品名称(英文)": "Product name(english)",
  "请您先同意承诺": "Please agree the commitment first"
}



// WEBPACK FOOTER //
// ./src/common/VueI18n/language-en.js